import { graphql } from '~/gql'

const RESULTS_DEALS_AND_ADS_QUERY = graphql(`
  query resultsDealsAndAdsQuery(
    $sjidVariant: SJIDVariant
    $slug: String
    $device: String
    $sortBy: SORT_BY
    $adsSortBy: SORT_BY
    $filters: Filters
    $adsFilters: Filters
    $limit: Int = 10
    $cursor: String
    $filterConfig: FilterConfig
    $comparisonId: String
    $previewFlag: Boolean
    $personalise: Boolean
    $showAds: Boolean!
    $widelyAvailable: Boolean = false
    $algorithmVersion: String
  ) {
    dealsFeed(
      sjidVariant: $sjidVariant
      slug: $slug
      filters: $filters
      sortBy: $sortBy
      limit: $limit
      cursor: $cursor
      device: $device
      filterConfig: $filterConfig
      comparisonId: $comparisonId
      previewFlag: $previewFlag
      personalise: $personalise
      widelyAvailable: $widelyAvailable
      algorithmVersion: $algorithmVersion
    ) {
      count
      comparisonId
      nextCursor
      previousCursor
      hasNextPage
      address {
        ...addressFields
      }
      maxSpeeds {
        type
        maxSpeed
      }
      availableFilters {
        ...availableFilterFields
      }
      deals {
        ...dealFields
      }
      previewFlag
    }
    allDealsFeed: dealsFeed(
      sjidVariant: $sjidVariant
      slug: $slug
      filters: $filters
      sortBy: $sortBy
      limit: $limit
      cursor: $cursor
      device: $device
      filterConfig: $filterConfig
      comparisonId: $comparisonId
      previewFlag: $previewFlag
      personalise: $personalise
      widelyAvailable: false
      algorithmVersion: $algorithmVersion
    ) @include(if: $widelyAvailable) {
      count
    }
    adsFeed(filters: $adsFilters, sortBy: $adsSortBy, slug: $slug, sjidVariant: $sjidVariant) @include(if: $showAds) {
      ads {
        ...adFeedFields
      }
      comparisonId
    }
  }
`)

export default RESULTS_DEALS_AND_ADS_QUERY
